import React, { ChangeEvent } from 'react'

import { Checkbox } from '@percent/lemonade'
import styles from './FieldCheckBox.module.scss'
import { FieldCheckBoxProps } from './FieldCheckBox.types'

// Children stay outside the checkbox's own <label>: a click on a label also clicks its input, which would
// fire twice for callers that handle the click on a surrounding element.
export function FieldCheckBox({
  children,
  onChange,
  name,
  active,
  disabled,
  indeterminate,
  value
}: FieldCheckBoxProps) {
  return (
    <div className={styles.container}>
      <Checkbox
        name={name}
        label={null}
        variant={indeterminate ? 'indeterminate' : 'default'}
        onChange={event => onChange?.(event as ChangeEvent<HTMLInputElement>)}
        active={active}
        disabled={disabled}
        id={`checkbox-${name}`}
        aria-label={`checkbox-${name}`}
        dataTestId={`checkbox-${name}`}
        {...(value && { value })}
      />
      {children}
    </div>
  )
}
